import MultiText, { MultiTextItem, MultiTextRenderOptions } from '@api-consent/classes/MultiText';

export default class ServiceProvider {
  id: string;
  title: string | MultiTextItem[];
  brand: string | MultiTextItem[];
  tenant: string | MultiTextItem[];
  description: string | MultiTextItem[];
  url: string | MultiTextItem[];
  brandId?: string;

  constructor({
    id, title, brand, tenant, description, url, brandId,
  }: {
    id: string,
    title: string | MultiTextItem[],
    brand: string | MultiTextItem[],
    tenant: string | MultiTextItem[],
    description: string | MultiTextItem[],
    url: string | MultiTextItem[],
    brandId?: string,
  }) {
    this.id = id;
    this.title = title;
    this.brand = brand;
    this.tenant = tenant;
    this.description = description;
    this.url = url;
    this.brandId = brandId;
  }

  getTitle(opts: MultiTextRenderOptions): string | undefined {
    return new MultiText(this.title).render(opts);
  }

  getBrand(opts: MultiTextRenderOptions): string | undefined {
    return new MultiText(this.brand).render(opts);
  }

  getTenant(opts: MultiTextRenderOptions): string | undefined {
    return new MultiText(this.tenant).render(opts);
  }

  getDescription(opts: MultiTextRenderOptions): string | undefined {
    return new MultiText(this.description).render(opts);
  }

  getUrl(opts: MultiTextRenderOptions): string | undefined {
    return new MultiText(this.url).render(opts);
  }
}
